export enum BookablePersonType {
  LEAD = 'Lead',
  MEMBER = 'Member',
}
